module.exports = __webpack_public_path__ + "img/arrecredihome2v_2.9cee42ab.webp";